"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const noop_1 = __importDefault(require("lodash/noop"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const PeopleOutlineOutlined_1 = __importDefault(require("@mui/icons-material/PeopleOutlineOutlined"));
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const accountGroupsActions_1 = require("companion-app-components/flux/account-groups/accountGroupsActions");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const accountsSelectors_1 = require("companion-app-components/flux/accounts/accountsSelectors");
const accountGroupUtils_1 = require("companion-app-components/flux/account-groups/accountGroupUtils");
const authSelectors_1 = require("companion-app-components/flux/auth/authSelectors");
const accountGroupsTypes_1 = require("companion-app-components/flux/account-groups/accountGroupsTypes");
const MainNavItem_1 = require("containers/App/Header/MainNavItem");
const EntitySelectNavButton = ({ classes, iconSize, canOpenSubMenu, closeHeader, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const currentDataset = (0, react_redux_1.useSelector)(authSelectors_1.getCurrentDataset);
    const isSharedDataset = Boolean(currentDataset === null || currentDataset === void 0 ? void 0 : currentDataset.shared);
    const accountGroups = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.getAccountGroups);
    const sharedAccountGroups = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.selectSharedAccountGroup);
    const showEntitySelection = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isAccountGroupEnabled);
    const selectedAccountGroupName = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.getCurrentAccountGroupName);
    const containsUnassignedAccounts = (0, react_redux_1.useSelector)(accountsSelectors_1.hasUnAssignedAccounts);
    const [selectedGroup, selectAccountGroupName] = (0, react_1.useState)(selectedAccountGroupName);
    const groups = (0, react_1.useMemo)(() => { var _a; return (_a = (isSharedDataset ? sharedAccountGroups : accountGroups)) !== null && _a !== void 0 ? _a : []; }, [isSharedDataset, sharedAccountGroups, accountGroups]);
    const hasFullAccess = (0, react_1.useMemo)(() => (0, accountGroupUtils_1.hasFullDatasetAccess)(currentDataset), [currentDataset]);
    const menuItems = (0, react_1.useMemo)(() => {
        let items = groups.map(({ name, id }) => ({ key: name, name, id }));
        if (showEntitySelection && (!isSharedDataset || hasFullAccess)) {
            items = [{ key: accountGroupsTypes_1.ALL_ACCOUNT_GROUPS, name: 'All Entities' }, ...items];
            if (containsUnassignedAccounts) {
                items.push({ key: accountGroupsTypes_1.UN_ASSIGNED_ACCOUNTS, name: 'Unassigned Accounts' });
            }
        }
        return items;
    }, [groups, isSharedDataset, containsUnassignedAccounts, showEntitySelection, hasFullAccess]);
    (0, react_1.useEffect)(() => {
        if (!showEntitySelection) {
            return;
        }
        if (selectedAccountGroupName !== selectedGroup) {
            selectAccountGroupName(selectedAccountGroupName);
        }
    }, [selectedAccountGroupName, selectedGroup, dispatch, showEntitySelection]);
    const handleItemClick = (menuItemClicked, groupId) => {
        closeHeader();
        selectAccountGroupName(menuItemClicked);
        dispatch((0, accountGroupsActions_1.selectAccountGroup)(menuItemClicked));
        if (groupId) {
            localStorage.setItem(accountGroupsTypes_1.LS_KEY_SELECTED_ENTITY, groupId);
        }
        else if ([accountGroupsTypes_1.ALL_ACCOUNT_GROUPS, accountGroupsTypes_1.UN_ASSIGNED_ACCOUNTS].includes(menuItemClicked)) {
            localStorage.setItem(accountGroupsTypes_1.LS_KEY_SELECTED_ENTITY, menuItemClicked);
        }
    };
    const hasEntityOptions = (isSharedDataset && !hasFullAccess) ? groups.length > 1 : groups.length > 0;
    if (!(showEntitySelection && hasEntityOptions)) {
        return null;
    }
    return (<MainNavItem_1.MainNavItem disableClick key="nav-item-entity-select" nav={{
            component: null,
            nav: 'main',
            title: 'Entities',
            alt: 'contains account owners list',
            img: PeopleOutlineOutlined_1.default,
            subMenuItems: menuItems,
        }} selected="" classes={classes} canOpenSubMenu={canOpenSubMenu} iconSize={iconSize} closeHeader={closeHeader} handleTracking={noop_1.default} renderSubMenuItems={menuItems.map(({ key, name, id }) => (<MenuItem_1.default key={key} onClick={() => handleItemClick(key, id)}>
          <Check_1.default fontSize="small" sx={{ visibility: key === selectedGroup ? 'visible' : 'hidden', mr: 1 }}/>
          {name}
        </MenuItem_1.default>))}/>);
};
exports.default = EntitySelectNavButton;
